import React, { useCallback, useEffect, useState } from 'react';
import { LearningAsset, LearningBook } from '../../../../model/response';
import AssetTree from './AssetTree';
import { findAllLearningBooks } from '../../../../service/learningBookService';
import { TablePaginationConfig } from 'antd';
import { getPageLearningAsset } from '../../../../service/learningAssetService';
import LearningAssetPage from './LearningAssetPage';

function AssetTreeManagement() {
  const [learningBookFetching, setLearningBookFetching] = useState(false);
  const [learningBooks, setLearningBooks] = useState<LearningBook[]>([]);
  const [learningAssetFetching, setLearningAssetFetching] = useState(false);
  const [learningAssets, setLearningAssets] = useState<LearningAsset[]>([]);
  const [selectedLearningBook, setSelectedLearningBook] = useState<LearningBook | null>(null);

  const [pagingParams, setPagingParams] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    defaultPageSize: 10,
  });

  const fetchLearningAssets = useCallback(async () => {
    if (selectedLearningBook) {
      setLearningAssetFetching(true);
      getPageLearningAsset({ pagination: pagingParams }, '', [], [], [selectedLearningBook.id])
        .then((learningAssetPage) => {
          setLearningAssets(learningAssetPage.content);
          setPagingParams({
            ...pagingParams,
            total: learningAssetPage.totalElements,
          });
        })
        .catch((error) => console.error(error))
        .finally(() => setLearningAssetFetching(false));
    }
  }, [selectedLearningBook, pagingParams]);

  useEffect(() => {
    fetchLearningAssets()
      .then()
      .catch((e) => console.error(e));
  }, [selectedLearningBook, pagingParams.pageSize, pagingParams.current]);

  useEffect(() => {
    setLearningBookFetching(true);
    findAllLearningBooks()
      .then((learningBooks) => {
        setLearningBooks(learningBooks);
        if (learningBooks.length) {
          setSelectedLearningBook(learningBooks[0]);
        }
      })
      .catch((e) => console.error(e))
      .finally(() => setLearningBookFetching(false));
  }, [setSelectedLearningBook]);

  return (
    <div className="w-full h-full bg-white flex flex-col">
      <div className="w-full flex gap-4 flex-1">
        <AssetTree
          selectedLearningBook={selectedLearningBook}
          setSelectedLearningBook={setSelectedLearningBook}
          learningBookFetching={learningBookFetching}
          learningBooks={learningBooks}
        />
        <div className="flex-1">
          {selectedLearningBook ? (
            <LearningAssetPage
              learningAssets={learningAssets}
              learningAssetFetching={learningAssetFetching}
              pagingParams={pagingParams}
              setPagingParams={setPagingParams}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default AssetTreeManagement;
